import React from 'react';
import { FaRegTimesCircle } from 'react-icons/fa';
import styles from './errorMessage.module.css';

function ErrorMessage(props) {
    return (
        <div className={styles.errorMessage}>
            <FaRegTimesCircle size={30} />
            <div>
                <p>{props.message}</p>
                {props.contact ? <p className='mt-2'>{props.contact}</p> : null}
            </div>
        </div>
    );
}

export default ErrorMessage;
